/**
 * Checks if a value represents an integer (whole number, no decimal).
 * Accepts strings or numbers. Returns false for non-numeric values.
 */
export const isInt = (value: string | number): boolean => {
  if (isNaN(Number(value))) {
    return false;
  }
  const x = parseFloat(String(value));
  return Number.isInteger(x);
};

/**
 * Checks whether a value is exactly a 10-digit numeric string (for NPI validation).
 */
export const isTenDigitInt = (value: string | number): boolean => {
  return /^\d{10}$/.test(String(value));
};